export default "__VITE_ASSET__5LspxAv0__"